(function () {

    'use strict';

    angular.module('asys', [
        'ngAnimate',
        'ngMessages',
        'ngCookies',
        'ui.router',
        'angular-spinkit',
        'angulartics',
        'ngStorage',
        'ngAria',
        'ngSanitize',
        'ngAria',
        'lodash',
        'modernizr',
        'fuzzysort',
        'moment',
        'iban',
        'numbro',
        'etEcWrapper',
        'bowser',
        'stacktrace',
        'md5',
        'libphonenumber',
        'mm.foundation.mediaQueries',
        'mm.foundation.position',
        'mm.foundation.transition',
        'mm.foundation.accordion',
        'mm.foundation.modal',
        'mm.foundation.templates',
        'iplusjs.config',
        'iplusjs.authentication',
        'iplusjs.utils.misc',
        'iplusjs.utils.tracking',
        'iplusjs.utils.schluesselWerte',
        'iplusjs.utils.binary',
        'iplusjs.utils.adresse',
        'iplusjs.utils.format',
        'iplusjs.utils.money',
        'iplusjs.utils.konto',
        'iplusjs.utils.html',
        'iplusjs.utils.device',
        'iplusjs.utils.formField',
        'iplusjs.utils.identityType',
        'iplusjs.utils.uppercase',
        'iplusjs.utils.button',
        'iplusjs.utils.removeWhitespace',
        'iplusjs.utils.vertrag',
        'iplusjs.utils.objectType',
        'iplusjs.utils.focusOnShow',
        'iplusjs.utils.scrollToTop',
        'iplusjs.utils.scrollIntoView',
        'iplusjs.alert.component',
        'iplusjs.alert.service',
        'iplusjs.navigation',
        'iplusjs.loadingIndicator',
        'iplusjs.fileupload',
        'iplusjs.filecache',
        'iplusjs.tooltip',
        'iplusjs.tooltip.info',
        'iplusjs.tooltip.content',
        'iplusjs.popoverField',
        'iplusjs.filepopup',
        'iplusjs.fieldset',
        'iplusjs.api',
        'iplusjs.api.cache',
        'iplusjs.log',
        'iplusjs.exceptionHandler',
        'iplusjs.exceptionHandler.eicis',
        'iplusjs.validationMessage',
        'iplusjs.adresseValidator',
        'iplusjs.validator',
        'iplusjs.asyncValidator',
        'iplusjs.validator.group',
        'iplusjs.validator.add',
        'iplusjs.validator.email',
        'iplusjs.validator.isEqualTo',
        'iplusjs.validator.navigation',
        'iplusjs.validator.plz',
        'iplusjs.validator.vertragsnummer',
        'iplusjs.validator.form',
        'iplusjs.validator.iban',
        'iplusjs.validator.isGreaterThan',
        'iplusjs.validator.isLowerThan',
        'iplusjs.validator.exists',
        'iplusjs.validator.kfzKennzeichen',
        'iplusjs.validator.banned',
        'iplusjs.validator.kfz.vbnummer',
        'iplusjs.validator.trigger',
        'iplusjs.druck.downloadLink',
        'iplusjs.integration',
        'iplusjs.integration.pkslogin',
        'iplusjs.integration.pksangemeldethinweis',
        'iplusjs.integration.pksregister',
        'iplusjs.inputNumber',
        'iplusjs.button.btn',
        'iplusjs.button.link',
        'iplusjs.schaltflaeche',
        'iplusjs.mapper.radioTrackBy',
        'iplusjs.mapper.objectValue',
        'iplusjs.mapper.identityType',
        'iplusjs.mapper.money',
        'iplusjs.mapper.objectType',
        'iplusjs.dateString',
        'iplusjs.filter.numberString',
        'iplusjs.filter.adresse',
        'iplusjs.filter.filterBy',
        'iplusjs.filter.moneyString',
        'iplusjs.filter.stringReplace',
        'iplusjs.filter.toTrusted',
        'iplusjs.filter.yesNo',
        'iplusjs.filter.monthName',
        'iplusjs.utils.bindHtmlCompile',
        'iplusjs.bloecke.upload',
        'iplusjs.footer',
        'iplusjs.print',
        'iplusjs.typeahead',
        'iplusjs.fahrzeugsuche.komfort',
        'iplusjs.fahrzeugsuche.detail',
        'iplusjs.adresseAuswahl',
        'iplusjs.overlay.wait',
        'iplusjs.iframe.events',
        'iplusjs.link',
        'iplusjs.input.kfzKennzeichen',

        'angulartics.wgv',
        'angulartics.etracker',
        'angulartics.hurra',

        'templates.app',
        'templates.common',
        'iplusjs.templates.common'
    ])
    .config(config)
    .run(run);

    config.$inject = [];
    function config() {}

    run.$inject = [];
    function run() {}
})();
